// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import PageNavbarController from '../../components/page/navbar_component/navbar_controller';
import EventChartController from '../../components/event_chart_component/event_chart_controller';
import BankErrorsChartController from '../../components/bank_errors_chart_component/bank_errors_chart_controller';
import TrendChartController from '../../components/trend_chart_component/trend_chart_controller';
import FormValidationController from './form_validation_controller';
import DashboardBanksProxyServerDisableController from './dashboard/banks/proxy_server_disable_controller';

application.register('page--navbar', PageNavbarController);
application.register('event-chart', EventChartController);
application.register('bank-errors-chart', BankErrorsChartController);
application.register('trend-chart', TrendChartController);
application.register('form-validation', FormValidationController);
application.register('dashboard--banks--proxy-server-disable', DashboardBanksProxyServerDisableController);
